import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import { mapGetters } from 'vuex';
import * as constants from '@/constants';
import { selectTree, selectCompany } from '@/api/basic-setting/csCompany';

/*eslint-disable*/
/**
 * 选择处理单位逻辑
 */
export default {
  data: function data() {
    return {
      // 树数据
      companyTreeData: [],
      companyTreeProps: {
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      // 列表数据
      companyListData: [],
      // form表单key：this[this.formKey]，默认'formData'
      formKey: 'formData',
      // 处理单位的form表单key：this[this.formKey][this.companyIdKey]，默认'companyId'
      companyIdKey: 'companyId'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['user'])), {}, {
    // 乙方用户不允许修改管理单位
    companyIdDisabled: function companyIdDisabled() {
      return this.user.type !== constants.ORG_TYPE_PARTY;
    }
  }),
  methods: {
    /**
     * 初始化处理单位树
     */
    initCompanyTreeData: function () {
      var _initCompanyTreeData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.user.type === constants.ORG_TYPE_PARTY)) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return selectTree();
            case 3:
              this.companyTreeData = _context.sent;
              _context.next = 7;
              break;
            case 6:
              this.companyTreeData = [{
                id: this.user.companyId,
                name: this.user.companyName,
                type: constants.ORG_TYPE_COMPANY
              }];
            case 7:
              callback && callback();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initCompanyTreeData(_x) {
        return _initCompanyTreeData.apply(this, arguments);
      }
      return initCompanyTreeData;
    }(),
    /**
     * 初始化处理单位树选中
     */
    initCompanyTreeId: function initCompanyTreeId(callback) {
      var companyId = null;
      if (this.user.type === constants.ORG_TYPE_PARTY) {
        companyId = this.user.partyId;
      } else {
        companyId = this.user.companyId;
      }
      this.$set(this[this.formKey], this.companyIdKey, companyId);
      callback && callback();
    },
    /**
     * 初始化处理单位列表
     *
     * @param selectAll
     * @param callback
     * @return {Promise<void>}
     */
    initCompanyListData: function () {
      var _initCompanyListData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(callback) {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return selectCompany(true);
            case 2:
              data = _context2.sent;
              this.companyListData = data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  value: item.id,
                  label: item.name
                });
              });
              this.$nextTick(function () {
                callback && callback();
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function initCompanyListData(_x2) {
        return _initCompanyListData.apply(this, arguments);
      }
      return initCompanyListData;
    }(),
    /**
     * 初始化处理单位列表选中
     *
     * @param callback
     */
    initCompanyListId: function initCompanyListId(callback) {
      var companyId = null;
      if (this.user.type !== constants.ORG_TYPE_PARTY) {
        companyId = this.user.companyId;
      } else {
        if (this.companyListData.length > 0) {
          companyId = this.companyListData[0].value;
        }
      }
      this.$set(this[this.formKey], this.companyIdKey, companyId);
      this.$nextTick(function () {
        callback && callback();
      });
    }
  }
};